const strize = require('../strize')
module.exports = {
  title: 'ECF',
  imgs: {
    root: 'imagesECF'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: true
  },
  bucket: {
    player: {
      bucket: strize('tgd2editor-test'),
      region: strize('eu-west-3'),
      key: strize(''),
      secret: strize('')
    },
    editor: {
      bucket: strize('tgd2editor-test'),
      region: strize('eu-west-3'),
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#c73c41',
    bgSideBar: '#232733',
    ActionMail: '#dadada'
  },
  layouts: {
    sidebar: {
      imgLogo: 'Logo.png'
    },
  }
}
